<template>
    <div>
        <h1 style="font-size: 24px; color: black;">图标分类管理</h1>
        <div style="margin-bottom: 10px;">
                <el-button type="primary" @click="showDetails('新增分类')">添加分类</el-button>
                <el-button type="primary" @click="jump">创建图标</el-button>
        </div>
        <h1>
            <el-table border
                      :data="iconCategories">
                <el-table-column  label="分类编号" prop="id"  align="center"></el-table-column>
                <el-table-column  label="分类名称" prop="name"  align="center"></el-table-column>
                <el-table-column  label="关联图标数"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.iconCounts}}
                    </template>
                </el-table-column>
                <el-table-column  label="排序"  align="center" width="250px">
                    <template slot-scope="scope" >
                        <el-input-number size="small" :min="0"  v-model="scope.row.ranking"  @change="updateRanking(scope.row)" ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间"  prop="createDt" :formatter="formatDate" align="center"></el-table-column>
                <el-table-column label="修改时间"  prop="updateDt" :formatter="formatDate" align="center"></el-table-column>
                <el-table-column  label="操作"  align="center" width="250px">
                    <template slot-scope="scope">
                        <el-button  plain size="mini" type="primary" @click="showDetails('编辑分类',scope.row)">编辑</el-button>
                        <el-button  plain size="mini" type="success" @click="iconSelect(scope.row)">关联图标</el-button>
                        <el-button  plain size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="categoryEditForm" :label-width="labelWidth">
                    <el-form-item label="分类名称:" >
                        <el-input  style="width: 300px" type="text" v-model="categoryEditForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="排序 :" :label-width="labelWidth">
                        <el-input-number  :min="0"  v-model="categoryEditForm.ranking"  ></el-input-number>
                    </el-form-item>

                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmForm">确 定</el-button>
                        <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </h1>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>

    </div>
</template>

<script>
    import {
        searchIconCategory,
        saveIconCategory,
        deleteIconCategory
    } from "@/http/iosApi";
    import utils from '@/utils';
    export default {
        name: "IconCategory",
        data(){
            return{
                iconCategories:[],
                labelWidth: '150px',
                dialogVisible: false,
                dialogTitle :'',
                categoryEditForm: {},
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                queryData:{}
            }
        },
        methods:{
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            jump(){
                this.$router.push({ path: '/icon'});
            },

            updateRanking(row){
                this.categoryEditForm = {
                    "id" : row.id,
                    "name" :row.name,
                    "ranking" : row.ranking,

                };
                this.$confirm('此操作将更改该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    saveIconCategory(this.blockEditForm).then(resp=> {
                        if (resp.data.status===0){
                          this.search();
                        }
                    })
                }).catch(() => {
                  this.search();
                });
            },
            showDetails(title, row) {
                this.categoryEditForm = {
                    "id" : 0,
                    "name" :'',
                    "ranking" : 0
                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.categoryEditForm = {
                        "id" : row.id,
                        "name" :row.name,
                        "ranking" : row.ranking
                    };
                }
            },
            confirmForm(){
                let _message = '';
                if(this.categoryEditForm.name===''){
                    _message = '请输入分类名称'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveIconCategory(this.categoryEditForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteIconCategory(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search()
                        }
                    });
                }).catch(() => {
                })
            },
            iconSelect(category){
                this.$store.commit('addCategory', category);
                this.$router.push({ path: '/selectIcon'});
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            search(){
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                searchIconCategory(this.queryData).then(resp=>{
                    this.iconCategories= resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },
        },
        created() {
            this.search();
        }
    }
</script>

<style scoped>

</style>